module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-18"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form-text', {
    attrs: {
      "label": "Search Conversations",
      "name": "searchconversations"
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/operations/wire/create"
    }
  }, [_vm._v("Add")])], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('conversations-table', {
    attrs: {
      "data": _vm.filteredData,
      "columns": _vm.gridColumns,
      "filter-key": _vm.searchQuery
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7bf9ea4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/wire/Wire.vue
// module id = 658
// module chunks = 1